import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    root: {
        marginBottom: theme.spacing(1)
    },
    paper: {
        width: '100%',
        padding: theme.spacing(2),
        textAlign: 'center'
    },
    fromControllerArray: {
        overflowY: "scroll",
        height: "19rem",
        fontSize: "1rem"
    },
    fab: {
        position: "fixed",
        bottom: theme.spacing(2),
        left: '81%'
    }
}));

export default useStyles;